import { sanitizeHtml } from '../utils/sanitizeHtml.js';

export default function SupplierRow({ supplier }) {
  return (
    <tr>
      <td>
        <strong>{supplier.Company}</strong>
        <br />

        {supplier.FullAddress && (
          <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(supplier.FullAddress) }} />
        )}

        <br />
        <strong>Phone:</strong> {supplier.WorkPhone || ''}
        <br />
        <strong>Fax:</strong> {supplier.Fax || ''}
        <br />

        {supplier.Website && (
          <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(supplier.Website) }} />
        )}

        <br />
        <br />
      </td>
    </tr>
  );
}
